// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sailing-hotel"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 22H8V2C11.6851 2.64088 14.0353 4.56529 15.4619 7C16.3579 8.52922 16.8896 10.2598 17.1589 12C17.4248 13.7187 17.4348 15.4469 17.2869 17C17.079 19.184 16.559 21.0217 16 22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.65 12H8M14.95 7H8M16.8 17H8M20 22H5M8 22V2C13.9996 3.04341 16.4609 7.48906 17.1589 12C17.7422 15.7701 17.0939 19.5857 16.25 21.499","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SailingHotelIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sailing-hotel',
    ref,
    icon: element,
  },
));

SailingHotelIcon.displayName = 'SailingHotelIcon';

export default SailingHotelIcon;
